<div class="card">
  <h3 class="card__title">Patch Compliance by Severity</h3>
  <div class="legend">
    <span><i style="background: var(--green)"></i>Compliant</span>
    <span><i style="background: var(--slate)"></i>Non-compliant</span>
  </div>
  <div class="vbars">
    <div
      class="vbar"
      *ngFor="let s of severities"
      [class.is-active]="activeSeverity === s.name"
      tabindex="0"
      (click)="severitySelect.emit(s.name)"
      (keydown.enter)="severitySelect.emit(s.name)"
    >
      <div class="vbar__col">
        <div class="vbar__fill" [style.height.%]="s.pct">{{ s.pct }}%</div>
      </div>
      <div class="vbar__name">{{ s.name }}</div>
    </div>
  </div>
</div>
